import { Hero } from '@/components/sections/Hero';
import { TrustStrip } from '@/components/sections/TrustStrip';
import { Capabilities } from '@/components/sections/Capabilities';
import { SecurityLayers } from '@/components/sections/SecurityLayers';
import { CapabilityDetails } from '@/components/sections/CapabilityDetails';
import { Comparison } from '@/components/sections/Comparison';
import { Faq } from '@/components/sections/Faq';
import { FinalCta } from '@/components/sections/FinalCta';
import { Metrics } from '@/components/sections/Metrics';
import { RecentInsights } from '@/components/blog/RecentInsights';

export function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <Metrics />
      <Capabilities />
      <SecurityLayers />
      <CapabilityDetails />
      <Comparison />
      <Faq />
      <RecentInsights />
      <FinalCta />
    </>
  );
}
